var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 97,
    viewBox: "0 0 97 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.5 84.5C68.3823 84.5 84.5 68.3823 84.5 48.5C84.5 28.6178 68.3823 12.5 48.5 12.5C28.6178 12.5 12.5 28.6178 12.5 48.5C12.5 68.3823 28.6178 84.5 48.5 84.5Z",
    fill: "url(#paint0_linear_245_95016)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8633 51.132L41.1344 62.9538C41.1344 62.9538 41.6684 64.0599 42.2402 64.0599C42.812 64.0599 51.3167 55.2123 51.3167 55.2123L60.7742 36.9453L37.0157 48.0804L36.8633 51.132Z",
    fill: "#C8DAEA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5374 54.166L41.7175 62.8798C41.7175 62.8798 41.3743 65.5498 44.0437 62.8798C46.7131 60.2098 49.2682 58.1509 49.2682 58.1509",
    fill: "#A9C6D8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9476 51.5548L28.1618 48.6922C28.1618 48.6922 27.1118 48.2662 27.4499 47.3002C27.5195 47.101 27.6599 46.9315 28.0799 46.6402C30.0266 45.2833 64.1117 33.0322 64.1117 33.0322C64.1117 33.0322 65.0741 32.7079 65.6417 32.9236C65.7821 32.9671 65.9085 33.0471 66.0078 33.1554C66.1072 33.2637 66.176 33.3965 66.2072 33.5401C66.2685 33.7938 66.2942 34.0549 66.2834 34.3156C66.2807 34.5412 66.2534 34.7503 66.2327 35.0782C66.0251 38.4277 59.8127 63.4261 59.8127 63.4261C59.8127 63.4261 59.441 64.8889 58.1093 64.939C57.782 64.9496 57.456 64.8942 57.1506 64.776C56.8452 64.6579 56.5667 64.4795 56.3318 64.2514C53.7185 62.0035 44.6861 55.9333 42.6902 54.5983C42.6452 54.5677 42.6073 54.5277 42.579 54.4811C42.5507 54.4345 42.5328 54.3824 42.5264 54.3283C42.4985 54.1876 42.6515 54.0133 42.6515 54.0133C42.6515 54.0133 58.3793 40.0333 58.7978 38.5657C58.8302 38.452 58.7078 38.3959 58.5434 38.4457C57.4988 38.83 39.3902 50.2657 37.3916 51.5278C37.2477 51.5714 37.0957 51.5806 36.9476 51.5548V51.5548Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_245_95016",
    x1: 48.5,
    y1: 84.5,
    x2: 48.5,
    y2: 12.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D93D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#38B0E3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/Telegram.034a5b82fe2cf120c051a6ceeb366ba7.svg";
export { ForwardRef as ReactComponent };